import { Box, Typography, useTheme } from "@mui/material";
import { useState } from "react";
import LeadMiningDetailsDrawer from "@/modules/lead-page/new/components/activity/lead-mining/drawer";
import { parseLeadMining } from "@/modules/lead-page/new/components/activity/lead-mining/parser";
import LeadMiningSections from "@/modules/lead-page/new/components/activity/lead-mining/sections";

interface LeadMiningContentProps {
  content: string;
  actorName?: string | null;
  actorColor?: string | null;
  createdAt?: string;
}

const LeadMiningContent = ({
  content,
  actorName,
  actorColor,
  createdAt,
}: LeadMiningContentProps) => {
  const theme = useTheme();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const d = parseLeadMining(content ?? "");
  const hasStructure =
    d.category ||
    (d.intent?.length ?? 0) > 0 ||
    d.salesRecommendation ||
    d.behaviorSummary ||
    d.journeyNarrative ||
    d.recommendedLeadType ||
    (d.extras?.length ?? 0) > 0;

  if (!hasStructure) {
    return (
      <Box
        sx={{
          padding: `${theme.nawy.spacing.sm} ${theme.nawy.spacing.md}`,
          borderRadius: theme.nawy.radius.md,
          background: theme.nawy.colors.semantic.layer.secondary,
        }}
      >
        <Typography
          sx={{
            ...theme.nawy.typography.english.variants.body.md.regular,
            color: theme.nawy.colors.semantic.text.primary,
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
          }}
        >
          {content}
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <LeadMiningSections
        data={d}
        onViewDetails={() => setDrawerOpen(true)}
        showJourneyNarrative={false}
        showExtras={false}
      />

      <LeadMiningDetailsDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        data={d}
        actorName={actorName}
        actorColor={actorColor}
        createdAt={createdAt}
      />
    </>
  );
};

export default LeadMiningContent;
